// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pagination-container {
  display: flex;
  list-style-type: none;
}
.pagination-container .pagination-item {
  padding: 0 12px;
  height: 32px;
  text-align: center;
  margin: auto 4px;
  color: rgba(0, 0, 0, 0.87);
  display: flex;
  box-sizing: border-box;
  align-items: center;
  letter-spacing: 0.01071em;
  border-radius: 16px;
  line-height: 1.43;
  font-size: 13px;
  min-width: 32px;
}
.pagination-container .pagination-item.dots:hover {
  background-color: transparent;
  cursor: default;
}
.pagination-container .pagination-item:hover {
  background-color: rgba(0, 0, 0, 0.04);
  cursor: pointer;
}
.pagination-container .pagination-item.selected {
  background-color: rgba(0, 0, 0, 0.08);
}
.pagination-container .pagination-item .arrow::before {
  position: relative;
  content: "";
  display: inline-block;
  width: 0.4em;
  height: 0.4em;
  border-right: 0.12em solid rgba(0, 0, 0, 0.87);
  border-top: 0.12em solid rgba(0, 0, 0, 0.87);
}
.pagination-container .pagination-item .arrow.left {
  transform: rotate(-135deg) translate(-50%);
}
.pagination-container .pagination-item .arrow.right {
  transform: rotate(45deg);
}
.pagination-container .pagination-item.disabled {
  pointer-events: none;
}
.pagination-container .pagination-item.disabled .arrow::before {
  border-right: 0.12em solid rgba(0, 0, 0, 0.43);
  border-top: 0.12em solid rgba(0, 0, 0, 0.43);
}
.pagination-container .pagination-item.disabled:hover {
  background-color: transparent;
  cursor: default;
}`, "",{"version":3,"sources":["webpack://./src/components/common/dataList/Pagination.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,qBAAA;AACJ;AACI;EACE,eAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,0BAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;AACN;AACM;EACE,6BAAA;EACA,eAAA;AACR;AACM;EACE,qCAAA;EACA,eAAA;AACR;AAEM;EACE,qCAAA;AAAR;AAIQ;EACE,kBAAA;EACA,WAAA;EACA,qBAAA;EACA,YAAA;EACA,aAAA;EACA,8CAAA;EACA,4CAAA;AAFV;AAKQ;EACE,0CAAA;AAHV;AAMQ;EACE,wBAAA;AAJV;AAQM;EACE,oBAAA;AANR;AAQQ;EACE,8CAAA;EACA,4CAAA;AANV;AASQ;EACE,6BAAA;EACA,eAAA;AAPV","sourcesContent":[".pagination-container {\n    display: flex;\n    list-style-type: none;\n  \n    .pagination-item {\n      padding: 0 12px;\n      height: 32px;\n      text-align: center;\n      margin: auto 4px;\n      color: rgba(0, 0, 0, 0.87);\n      display: flex;\n      box-sizing: border-box;\n      align-items: center;\n      letter-spacing: 0.01071em;\n      border-radius: 16px;\n      line-height: 1.43;\n      font-size: 13px;\n      min-width: 32px;\n  \n      &.dots:hover {\n        background-color: transparent;\n        cursor: default;\n      }\n      &:hover {\n        background-color: rgba(0, 0, 0, 0.04);\n        cursor: pointer;\n      }\n  \n      &.selected {\n        background-color: rgba(0, 0, 0, 0.08);\n      }\n  \n      .arrow {\n        &::before {\n          position: relative;\n          content: '';\n          display: inline-block;\n          width: 0.4em;\n          height: 0.4em;\n          border-right: 0.12em solid rgba(0, 0, 0, 0.87);\n          border-top: 0.12em solid rgba(0, 0, 0, 0.87);\n        }\n  \n        &.left {\n          transform: rotate(-135deg) translate(-50%);\n        }\n  \n        &.right {\n          transform: rotate(45deg);\n        }\n      }\n  \n      &.disabled {\n        pointer-events: none;\n  \n        .arrow::before {\n          border-right: 0.12em solid rgba(0, 0, 0, 0.43);\n          border-top: 0.12em solid rgba(0, 0, 0, 0.43);\n        }\n  \n        &:hover {\n          background-color: transparent;\n          cursor: default;\n        }\n      }\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
